import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_USER_DASHBOARD,
  GET_USER_DETAILS_FOR_PROGRESS_BAR,
  POST_DISMISS_PROGRESS_BAR
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { BIBlue } from "../../assets/helpers";
import {
  Box,
  Button,
  Card,
  LinearProgress,
  Stack,
  Typography
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import StarsOutlinedIcon from "@mui/icons-material/StarsOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import PromptModal from "../common/PromptModal";
import { Postrequestcall } from "../../request/Postrequest";
import { English } from "../../constant/EnglishFallback";
import { setDashboardData } from "../../redux/actions/actions";

function ProgressBar(props) {
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, dashboardData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const token = loginData?.accessToken;

  const nav = useNavigate();
  const [isPrograssBar, setIsPrograssBar] = useState(true);
  const [progressStatus, setProgressStatus] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [progressLoading, setProgressLoading] = useState(true);
  const [tasksCompleteStatus, setTasksCompleteStatus] = useState(false);
  const [isProgressBarExpanded, setIsProgressBarExpanded] = useState(false);
  const [showProgressBarDismissModal, setShowProgressBarDismissModal] = useState(false);
  const [progressBardDetails, setProgressBarDetails] = useState({
    userTrade1: false,
    userFollowingProject: false,
    userEducation: false,
    userExperience: false,
    userExperience1: false,
    userBuilderBucks: false
  });

  const {
    PROGRESS_HEADING = English?.Home?.PROGRESS_HEADING,
    PROGRESS_SUBHEADING_1 = English?.Home?.PROGRESS_SUBHEADING_1,
    PROGRESS_SUBHEADING_2 = English?.Home?.PROGRESS_SUBHEADING_2,
    PROGRESS_SUBHEADING_3 = English?.Home?.PROGRESS_SUBHEADING_3,
    PROGRESS_SUBHEADING_4 = English?.Home?.PROGRESS_SUBHEADING_4,
    PROGRESS_SUBHEADING_5 = English?.Home?.PROGRESS_SUBHEADING_5,
    PROGRESS_BUTTON_DISMISS = English?.Home?.PROGRESS_BUTTON_DISMISS,
    TEXT_GO_TO_PROFILE = English?.Home?.TEXT_GO_TO_PROFILE,
    PROGRESS_ALERT_TITLE = English?.Home?.PROGRESS_ALERT_TITLE,
    TEXT_DELETE = English?.Home?.TEXT_DELETE
  } = multiLanguageData?.Home || {};

  useEffect(() => {
    if (userId && token) {
      getUserDetails();
    }
  }, [userId, token, props?.dashboardData?.isProgressBarDismiss]);

  const dismissProgressBar = async () => {
    try {
      const obj = {
        Id: userId
      };
      await Postrequestcall(POST_DISMISS_PROGRESS_BAR, obj, token);
      setIsPrograssBar(true);
      setTasksCompleteStatus(false);
      setProgressLoading(false);
      setShowProgressBarDismissModal(false);
      if (dashboardData) {
        dispatch(setDashboardData({ ...dashboardData, isProgressBarDismiss: true }));
      }
    } catch (error) {
      console.log("dismissProgressBar-> Error While Dismissing The Progress Bar: ", error);
    }
  };

  const getUserDetails = async () => {
    try {
      let progressBarInfo;
      if (props?.from == "new-dashboard") {
        progressBarInfo = props?.dashboardData;
        setIsPrograssBar(props?.dashboardData?.isProgressBarDismiss);
      } else {
        const res2 = await Getrequestcall(`${GET_USER_DASHBOARD}/${userId}`, token);

        const userDashboardData = res2?.data?.data;
        setIsPrograssBar(userDashboardData?.isProgressBarDismiss);

        const userResponse = await Getrequestcall(
          `${GET_USER_DETAILS_FOR_PROGRESS_BAR}/${userId}`,
          token
        );
        progressBarInfo = userResponse?.data?.data[0];
      }
      if (
        progressBarInfo?.userTrade &&
        progressBarInfo?.followingProject &&
        progressBarInfo?.education &&
        (progressBarInfo?.experience || progressBarInfo?.experience1) &&
        progressBarInfo?.builderbuck
      ) {
        setTasksCompleteStatus(true);
      } else {
        setTasksCompleteStatus(false);
      }
      const completedTasks = [
        progressBarInfo?.userTrade,
        progressBarInfo?.followingProject,
        progressBarInfo?.education,
        progressBarInfo?.experience || progressBarInfo?.experience1,
        progressBarInfo?.builderbuck
      ].filter(Boolean).length;

      setCompletedCount(completedTasks);
      setProgressStatus((completedTasks / 5) * 100);
      setProgressBarDetails({
        userTrade1: progressBarInfo?.userTrade,
        userFollowingProject: progressBarInfo?.followingProject,
        userEducation: progressBarInfo?.education,
        userExperience: progressBarInfo?.experience,
        userExperience1: progressBarInfo?.experience1,
        userBuilderBucks: progressBarInfo?.builderbuck
      });
      setProgressLoading(false);
    } catch (e) {
      console.log("getUserDetails-> Error while getting Progress Bar Details: ", e);
    }
  };

  const tasks = [
    {
      id: "trade",
      completed: !!progressBardDetails?.userTrade1,
      title: PROGRESS_SUBHEADING_1,
      icon: <HandymanOutlinedIcon sx={{ color: BIBlue, fontSize: 18 }} />,
      onClick: () => {
        nav(`/${userId}`, { state: { openTradeModal: true } });
      }
    },
    {
      id: "project",
      completed: !!progressBardDetails?.userFollowingProject,
      title: PROGRESS_SUBHEADING_2,
      icon: <StarBorderRoundedIcon sx={{ color: BIBlue, fontSize: 18 }} />,
      onClick: () => {
        nav("/sites");
      }
    },
    {
      id: "education",
      completed: !!progressBardDetails?.userEducation,
      title: PROGRESS_SUBHEADING_3,
      icon: <SchoolOutlinedIcon sx={{ color: BIBlue, fontSize: 18 }} />,
      onClick: () => {
        nav(`/${userId}`, { state: { scrollTo: "education-section" } });
      }
    },
    {
      id: "experience",
      completed: !!(progressBardDetails?.userExperience || progressBardDetails?.userExperience1),
      title: PROGRESS_SUBHEADING_4,
      icon: <WorkOutlineOutlinedIcon sx={{ color: BIBlue, fontSize: 18 }} />,
      onClick: () => {
        nav(`/${userId}`, { state: { scrollTo: "experience-section" } });
      }
    },
    {
      id: "builderbuck",
      completed: !!progressBardDetails?.userBuilderBucks,
      title: PROGRESS_SUBHEADING_5,
      icon: <StarsOutlinedIcon sx={{ color: BIBlue, fontSize: 18 }} />,
      onClick: () => {
        nav("/reward-store");
      }
    }
  ];

  const pendingTasks = tasks.filter((task) => !task.completed);

  const renderContent = () => {
    if (progressLoading || isPrograssBar || tasksCompleteStatus) {
      return null;
    }

    const itemsToDisplay = isProgressBarExpanded
      ? pendingTasks
      : pendingTasks.slice(0, 1);

    const content = (
      <Box
        className={props?.from === "new-dashboard" ? "" : "pagelist-content"}
        sx={{
          p: { xs: 1.5, sm: 1.75 },
          display: "flex",
          flexDirection: "column",
          gap: 1.25
        }}
      >
        {/* Top Header Row: Badge + Heading */}
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <Box
            sx={{
              backgroundColor: "#FEF3C7",
              color: "#78350F",
              fontWeight: 700,
              fontSize: "0.75rem",
              px: 1,
              py: 0.2,
              borderRadius: "12px",
              minWidth: "fit-content",
              lineHeight: 1.2
            }}
          >
            {completedCount}/5
          </Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "0.85rem", sm: "0.88rem" },
              color: "#1E293B",
              lineHeight: 1.3
            }}
          >
            {PROGRESS_HEADING}
          </Typography>
        </Stack>

        {/* Progress Bar Track */}
        <LinearProgress
          variant="determinate"
          value={progressStatus}
          sx={{
            backgroundColor: "#E2E8F0",
            borderRadius: "6px",
            height: "6px",
            ".MuiLinearProgress-bar": {
              backgroundColor: BIBlue,
              borderRadius: "6px"
            }
          }}
        />

        {/* Task Items List */}
        <Stack spacing={0.9}>
          {itemsToDisplay.map((task) => (
            <Box
              key={task.id}
              onClick={task.onClick}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                py: 0.75,
                px: 1.25,
                backgroundColor: "#F3F4F6",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "all 0.15s ease-in-out",
                "&:hover": {
                  backgroundColor: "#E5E7EB",
                  transform: "translateX(2px)"
                }
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                  flexShrink: 0
                }}
              >
                {task.icon}
              </Box>
              <Typography
                sx={{
                  color: "#1E293B",
                  fontWeight: 600,
                  fontSize: "0.84rem"
                }}
              >
                {task.title}
              </Typography>
            </Box>
          ))}
        </Stack>

        {/* Show More / Show Less Toggle Button */}
        {pendingTasks.length > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", my: -0.25 }}>
            <Button
              onClick={() => setIsProgressBarExpanded(!isProgressBarExpanded)}
              endIcon={
                isProgressBarExpanded ? (
                  <KeyboardArrowUpIcon sx={{ fontSize: "1.1rem !important" }} />
                ) : (
                  <KeyboardArrowDownIcon sx={{ fontSize: "1.1rem !important" }} />
                )
              }
              sx={{
                textTransform: "none",
                color: BIBlue,
                fontWeight: 600,
                fontSize: "0.8rem",
                p: 0.25,
                minHeight: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                  textDecoration: "underline"
                }
              }}
            >
              {isProgressBarExpanded ? "Show less" : "Show more"}
            </Button>
          </Box>
        )}

        {/* Bottom Actions Row */}
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mt: 0.25 }}>
          <Button
            onClick={() => setShowProgressBarDismissModal(true)}
            sx={{
              backgroundColor: "#F3F4F6",
              color: "#4B5563",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "8px",
              px: 2.25,
              py: 0.65,
              fontSize: "0.84rem",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#E5E7EB",
                boxShadow: "none"
              }
            }}
          >
            {PROGRESS_BUTTON_DISMISS || "Dismiss"}
          </Button>

          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon sx={{ fontSize: "1rem !important" }} />}
            onClick={() => nav(`/${userId}`)}
            sx={{
              backgroundColor: BIBlue,
              color: "#FFFFFF",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "8px",
              flex: 1,
              py: 0.65,
              fontSize: "0.84rem",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#063194",
                boxShadow: "none"
              }
            }}
          >
            {TEXT_GO_TO_PROFILE || "Go to Profile"}
          </Button>
        </Stack>
      </Box>
    );

    if (props?.from === "new-dashboard") {
      return (
        <Card
          sx={{
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
            border: "1px solid #f1f5f9",
            transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
              borderColor: "#cbd5e1"
            }
          }}
        >
          {content}
        </Card>
      );
    }

    return content;
  };

  return (
    <>
      {renderContent()}

      {showProgressBarDismissModal && (
        <PromptModal
          isOpen={showProgressBarDismissModal}
          onClose={() => setShowProgressBarDismissModal(false)}
          title={PROGRESS_ALERT_TITLE}
          redButtonText={TEXT_DELETE}
          onRedButtonClick={() => {
            dismissProgressBar();
          }}
        />
      )}
    </>
  );
}

export default ProgressBar;
